module.exports = __webpack_public_path__ + "babec86add37f888044d1ec5bc24a4b2.png";